import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';
import * as SendView from '../../../send-view/components/send-tabs/send-tabs.style';

export const StyledTabsList = styled(SendView.StyledTabsList)`
  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const StyledTab = styled(SendView.StyledTab)`
  color: ${(props) => props.active
    ? themeGet('colors.primary.regular')
    : themeGet('colors.input.checkbox')};
`;
